import { useState, useRef, useEffect } from 'react';
import { MoreVertical, FileText, Download, ArrowUpDown, Trash2, RefreshCw } from 'lucide-react';

export function ExportMenu({ onExportCSV, onExportText, onReorder, onDeleteList, onRegenerateList, hasItems }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors"
        aria-label="Shopping list options"
      >
        <MoreVertical className="w-5 h-5 text-gray-700" />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-12 bg-white rounded-2xl shadow-lg py-2 min-w-[200px] z-10">
          {hasItems ? (
            // Show all options when list has items
            <>
              {onReorder && (
                <button
                  onClick={() => {
                    onReorder();
                    setIsOpen(false);
                  }}
                  className="w-full px-4 py-3 text-left hover:bg-gray-50 flex items-center gap-3 text-gray-700"
                >
                  <ArrowUpDown className="w-5 h-5" />
                  <span>Reorder Items</span>
                </button>
              )}
              <button
                onClick={() => {
                  onExportCSV();
                  setIsOpen(false);
                }}
                className="w-full px-4 py-3 text-left hover:bg-gray-50 flex items-center gap-3 text-gray-700"
              >
                <Download className="w-5 h-5" />
                <span>Export as CSV</span>
              </button>
              <button
                onClick={() => {
                  onExportText();
                  setIsOpen(false);
                }}
                className="w-full px-4 py-3 text-left hover:bg-gray-50 flex items-center gap-3 text-gray-700"
              >
                <FileText className="w-5 h-5" />
                <span>Export as Text</span>
              </button>
              {onDeleteList && (
                <>
                  <div className="my-2 border-t border-gray-200" />
                  <button
                    onClick={() => {
                      onDeleteList();
                      setIsOpen(false);
                    }}
                    className="w-full px-4 py-3 text-left hover:bg-red-50 flex items-center gap-3 text-[#C85534]"
                  >
                    <Trash2 className="w-5 h-5" />
                    <span>Delete List</span>
                  </button>
                </>
              )}
              {onRegenerateList && (
                <button
                  onClick={() => {
                    onRegenerateList();
                    setIsOpen(false);
                  }}
                  className="w-full px-4 py-3 text-left hover:bg-gray-50 flex items-center gap-3 text-gray-700"
                >
                  <RefreshCw className="w-5 h-5" />
                  <span>Regenerate List</span>
                </button>
              )}
            </>
          ) : (
            // Only show Regenerate List when list is empty
            onRegenerateList && (
              <button
                onClick={() => {
                  onRegenerateList();
                  setIsOpen(false);
                }}
                className="w-full px-4 py-3 text-left hover:bg-gray-50 flex items-center gap-3 text-gray-700"
              >
                <RefreshCw className="w-5 h-5" />
                <span>Regenerate List</span>
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
}
